module.exports = __webpack_public_path__ + "media/audio1.7c10a9ea.mp4";